import { motion } from "framer-motion";
import { ArrowRight, Music2, Disc3, PlaySquare } from "lucide-react";

const LINKS = [
  {
    label: "Spotify",
    href: "https://open.spotify.com/album/6CEAKGPPKCVDnpSZ0VEhi1?si=a6Uvoj5kTwiY4CE8cQ1pAw&utm_source=copy-link&nd=1&dlsi=ac0e48dd124f4ac1",
    icon: Music2,
  },
  {
    label: "YouTube Music",
    href: "https://music.youtube.com/playlist?list=OLAK5uy_nUpN6IPF00C2F3V3Qtqz9ab5mmtNsL48Y&si=Q8YwaqxCT2J7kbhm",
    icon: PlaySquare,
  },
  {
    label: "Apple Music",
    href: "https://music.apple.com/id/album/youngest/6786929443",
    icon: Disc3,
  },
];

export default function YoungestLanding() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-black text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/youngest-bg.jpg')" }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-black/20" aria-hidden />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/15 to-black/45" aria-hidden />

      <section className="relative z-10 min-h-screen flex items-end justify-center px-5 pt-8 pb-16 sm:px-8 sm:pt-10 sm:pb-20">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="w-full max-w-md space-y-3.5"
        >
          <div className="mb-4 text-center drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
            <p className="text-[0.65rem] uppercase tracking-[0.35em] font-semibold text-white/85">
              listen now
            </p>
            <h1 className="mt-2 font-display text-4xl leading-none text-white">
              YOUNGEST
            </h1>
            <p className="mt-2 text-xs uppercase tracking-[0.22em] font-semibold text-white/80">
              Young K 2nd Full Album
            </p>
          </div>

          {LINKS.map(({ label, href, icon: Icon }, index) => (
            <motion.a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.08 * index }}
              className="group flex items-center justify-between gap-4 rounded-[1.35rem] border border-white/20 bg-white/10 px-5 py-3.5 text-white shadow-[0_8px_24px_rgba(0,0,0,0.12)] backdrop-blur-[4px] transition-all duration-300 ease-out hover:-translate-y-0.5 hover:bg-white/16 hover:shadow-[0_12px_30px_rgba(0,0,0,0.16)] active:scale-[0.99]"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/22 bg-white/10 transition group-hover:bg-white/16">
                  <Icon className="h-5 w-5" strokeWidth={1.7} />
                </span>
                <span>
                  <span className="block text-sm uppercase tracking-[0.24em] font-semibold leading-none drop-shadow-sm">
                    {label}
                  </span>
                </span>
              </span>
              <ArrowRight className="h-4.5 w-4.5 transition-transform group-hover:translate-x-1" strokeWidth={1.6} />
            </motion.a>
          ))}
        </motion.div>
      </section>
    </main>
  );
}
